import React, { useEffect, useState } from "react";
import PageHeading from "../../../components/PageHeading";
import {
  AddButton,
  BackButton,
  Button,
  HelpButton,
  SaveButton,
} from "../../../components/btn/Buttons";
import Table from "../../../components/table/Table";
import Dropdown from "../../../components/inputs/Dropdown";
import { Input } from "../../../components/inputs/Inputs";
import axios from "axios";
import { BLPGPriceAPI } from "../../../utils/apis";
import SmallModal from "../../../components/modal/SmallModal";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import PageLoading from "../../../components/PageLoading";
import { useNavigate } from "react-router-dom";
import "../../../CSS/masterData.css";
import { DeleteIcon } from "../../../utils/utils";
import { motion } from "framer-motion";
import { DateValidator2 } from "../../../utils/validation";
import moment from "moment";
import { Pagination2 } from "../../../components/pagination/pagination";
import { PinVerify } from "../../OtherComponent/PinVerify";
import store from "../../../redux/store";
import { get_arb_list, get_blpg_price_list } from "../masterdataSlice";
import { useSelector } from "react-redux";
import RowTxt from "../../../components/RowTxt";
import { HiOutlineArrowRight } from "react-icons/hi";
import NoData from "../../../components/NoData";
import Modal from "../../../components/modal/Modal";
import { Alerts } from "../../../components/Alerts/Alerts";
const monthFirstDate = moment().startOf("month").format("DD/MM/YYYY");

export const BLPGPrice = () => {
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showPinVerify, setShowPinVerify] = useState(true);
  const [DeleteId, setDeleteId] = useState("");
  const [pinALert, setPinAlert] = useState(false);
  const [pinAlertMess, setPinAlertMess] = useState("");
  const [addProductData, setAddProductData] = useState([]);
  const [viewItem, setViewItem] = useState([]);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [entries1, setEntries1] = useState("5");
  const [pageNo1, setPageNo1] = useState(1);
  const [SerchInput1, setSearchInput1] = useState("");
  const [show, setShow] = useState({
    showAdd: false,
    showLoading: false,
    showLoader: false,
  });
  const [showLoader, setShowLoader] = useState(false);
  const [entries, setEntries] = useState("5");
  const [pageNo, setPageNo] = useState(1);
  const [SerchInput, setSearchInput] = useState("");
  const [totalCount, setTotalCount] = useState("");

  const navigate = useNavigate();
  const userIdString = localStorage.getItem("userId");
  const OMC = JSON.parse(userIdString)?.OMC;
  const obj = {
    pageNo: pageNo,
    entries: entries,
    setTotalCount: setTotalCount,
  };
  const { blpg_price_list, blpg_price_loading, arb_list } = useSelector(
    (state) => state.masterdata
  );
  const { eff_date, today, user_id, emp_id, user_type, } = useSelector((state) => state.other);
  const { day_end_date } = useSelector((state) => state.profile);

  useEffect(() => {
    store.dispatch(get_arb_list());
  }, []);

  const handleDeleteProduct = async (deleteid) => {
    setShowLoader(true);
    const body = new FormData();
    body.append("action", "delete");
    body.append("agencyid", user_id);
    body.append("id", deleteid);
    if (emp_id) {
      body.append("emp_code", emp_id);
    }
    const response = await axios.post(BLPGPriceAPI, body);
    setShowLoader(false);
    if (response.data.success === true) {
      setShowDeleteAlert(false);
      toast(response.data.message, {
        position: "top-center",
      });

      if (blpg_price_list?.length < 2) {
        setPageNo(pageNo - 1);
        store.dispatch(
          get_blpg_price_list({
            pageNo: pageNo - 1,
            entries: entries,
            setTotalCount: setTotalCount,
          })
        );
      } else {
        store.dispatch(get_blpg_price_list(obj));
      }
    } else {
      setShow({ ...show, showDeleteAlert: false });
    }
  };

  const handleAddProduct = () => {
    const lastproduct = addProductData[addProductData.length - 1];
    if (addProductData.length === 0) {
      setAddProductData([
        {
          id: addProductData.length + 1,
          PRODUCTID: "",
          PRODUCT: "",
          RSP: "",
          BASIC: "",
          SGST: "",
          CGST: "",
          OFFER: "",
        },
      ]);
    } else {
      if (
        lastproduct?.PRODUCT != "" &&
        lastproduct?.RSP.length > 0 &&
        lastproduct?.OFFER.length > 0 &&
        lastproduct?.BASIC.length > 0 &&
        lastproduct?.SGST.length > 0 &&
        lastproduct?.CGST.length > 0 &&
        lastproduct?.RSP >= lastproduct?.OFFER &&
        (lastproduct?.RSP * 65) / 100 <= lastproduct?.OFFER
      ) {
        setAddProductData((prevData) => [
          ...prevData,
          {
            id: addProductData.length + 1,
            PRODUCTID: "",
            PRODUCT: "",
            RSP: "",
            BASIC: "",
            SGST: "",
            CGST: "",
            OFFER: "",
          },
        ]);
      } else {
        setPinAlert(true);
        setPinAlertMess(
          "Please enter all the values in current row,calculate and then add next row"
        );
      }
    }
  };

  const handleCalculate = () => {
    if (addProductData.length !== 0) {
      addProductData.forEach((product, index) => {
        if (
          product.PRODUCT !== "" &&
          product.RSP.length > 0 &&
          product.OFFER.length > 0 &&
          Number(product.RSP) >= Number(product.OFFER) &&
          (product.RSP * 65) / 100 <= product.OFFER
        ) {
          const basicPrice = (product.RSP / (1 + product.gst / 100)).toFixed(2);
          const sgst = ((basicPrice * (product.gst / 2)) / 100).toFixed(2);
          const cgst = ((basicPrice * (product.gst / 2)) / 100).toFixed(2);

          setAddProductData((prevData) => {
            const updatedData = [...prevData];
            updatedData[index] = {
              ...updatedData[index],
              BASIC: basicPrice,
              SGST: sgst,
              CGST: cgst,
            };
            return updatedData;
          });
        } else {
          setPinAlert(true);
          let alertMessage = "";
          if (product.PRODUCT === "") {
            alertMessage = "Please Select The PRODUCT";
          } else if (product.RSP.length <= 0) {
            alertMessage = "Please enter RSP";
          } else if (product.OFFER.length <= 0) {
            alertMessage = "Please enter OFFER PRICE.";
          } else if (Number(product.RSP) < Number(product.OFFER)) {
            alertMessage = "OFFER PRICE must be less than or equal to RSP";
          } else if ((product.RSP * 65) / 100 > product.OFFER) {
            alertMessage = "OFFER PRICE must be at least 65% of RSP.";
          }
          setPinAlertMess(alertMessage);
        }
      });
    } else {
      setPinAlert(true);
      setPinAlertMess("PLEASE ADD REFILL PRICE DATA AND CLICK CALCULATE");
    }
  };

  const valiDate = async () => {
    const data = [];

    if (addProductData?.length > 0) {
      for (let v of addProductData) {
        if (!v?.PRODUCT || (v?.PRODUCT && v?.PRODUCT.length === 0)) {
          data.push("Please Select Product.");
        }
        if (!v?.RSP || (v?.RSP && v?.RSP?.length == 0)) {
          data.push("Please Enter RSP Price.");
        } else if (Number(v?.RSP) <= 0) {
          data.push(" RSP Price can be Zero.");
        }

        if (!v?.OFFER || (v?.OFFER && v?.OFFER?.length == 0)) {
          data.push("Please Enter OFFER Price.");
        } else if (Number(v?.OFFER) <= 0) {
          data.push(" OFFER Price can be Zero.");
        }
        if (
          v?.RSP?.length > 0 &&
          v?.OFFER?.length > 0 &&
          (!v?.BASIC ||
            v?.BASIC == "" ||
            !v?.CGST ||
            v?.CGST == "" ||
            !v?.SGST ||
            v?.SGST == "")
        ) {
          data.push(" Please Click on Calculate");
        }
        const data1 = await DateValidator2(
          moment(v?.open_date).format("DD/MM/YYYY"),
          today,
          day_end_date,
          `Effective Date cant be before ${day_end_date} `,
          `Effective Date cant be a future date`
        );
        if (!v?.open_date || (v?.open_date && v?.open_date.length === 0)) {
          data.push("Please Enter EFFECTIVE DATE");
        } else if (data1 != true) {
          data.push(...data1);
        }
      }
    } else {
      data.push("Please Add Product First");
    }
    return data;
  };

  const handleSaveProduct = async () => {
    const data = await valiDate();
    if (data.length == 0) {
      try {
        setShowLoader(true);
        const body = new FormData();
        body.append("action", "create");
        body.append("agencyid", user_id);
        if (emp_id) {
          body.append("emp_code", emp_id);
        }
        addProductData.forEach((item) => {
          if (item) {
            body.append("arbcode[]", item?.PRODUCTID);
            body.append("base[]", item?.BASIC);
            body.append("offer[]", item?.OFFER);
            body.append("sgst[]", item?.SGST);
            body.append("cgst[]", item?.CGST);
            body.append("rsp[]", item?.RSP);
            body.append("openingdate[]", item?.open_date);
          }
        });
        const response = await axios.post(BLPGPriceAPI, body);
        setShowLoader(false);
        if (response.data.success) {
          setAddProductData([]);
          toast.success(response.data.message, {
            position: "top-center",
          });
          store.dispatch(get_blpg_price_list(obj));
        } else {
          setPinAlert(true);
          setPinAlertMess(response.data.message.toUpperCase());
        }
      } catch (error) {
        console.error("Error while posting data:", error);
        setShowLoader(false);
        setPinAlert(true);
        setPinAlertMess("Error occurred. Please try again later.");
      }
    } else {
      setPinAlertMess(
       <Alerts data={data}/>
      );
      setPinAlert(true);
    }
  };

  const handleAddDelete = (deleteId) => {
    const filterData = addProductData.filter((item) => item.id !== deleteId);
    setAddProductData(filterData);
  };

  useEffect(() => {
    store.dispatch(get_blpg_price_list(obj));
  }, [pageNo, entries]);

  const handleView = (item) => {
    setViewItem(item);
    setOpenViewModal(true);
  };

  return (
    <div className="container">
      <PageHeading
        title={
          (OMC == 1 && "NFR ITEMS PRICE MASTER") ||
          (OMC == 2 && "ARB ITEMS PRICE MASTER") ||
          (OMC == 3 && "BLPG ITEMS PRICE MASTER")
        }
        right={
          <>
            <AddButton
              onClick={() => {
                setShow({ ...show, showAdd: true });
                handleAddProduct();
              }}
            />
            {addProductData?.length > 0 && (
              <>
                <Button onClick={handleCalculate} title={"CALCULATE"} />
                <SaveButton title={"SAVE"} onClick={handleSaveProduct} />
              </>
            )}
           
            <BackButton onClick={() => navigate(-1)} />
            <HelpButton
              link={[
                "https://youtu.be/xOj5OoKynu4",
                "https://youtu.be/6I1OcbiKz8E",
              ]}
            />
          </>
        }
      />

      {show.showAdd && addProductData.length != 0 && (
        <>
          <Table
            mt={30}
            headData={[
              "PRODUCT",
              "RSP PRICE",
              "BASIC PRICE",
              "SGST AMOUNT",
              "CGST AMOUNT",
              "OFFER PRICE",
              "OPENING DATE",
              "ACTIONS",
            ]}
            body={
              <>
                {addProductData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Dropdown
                        value={item.PRODUCTID}
                        onChange={(e) => {
                          const filterData = arb_list.filter(
                            (equipment) => equipment.ID == e.target.value
                          );

                          setAddProductData((prevData) => {
                            const updatedData = [...prevData];
                            updatedData[index] = {
                              ...updatedData[index],
                              PRODUCT: filterData[0].PROD_NAME,
                              PRODUCTID: filterData[0].ID,
                              gst: filterData[0]?.GSTP,
                              BASIC: "",
                              SGST: "",
                              CGST: "",
                            };
                            return updatedData;
                          });
                        }}
                        options={
                          <>
                            <option hidden>SELECT</option>
                            {arb_list.length > 0 && (
                              <>
                                {arb_list.map((equipment, i) => (
                                  <option key={i} value={equipment.ID}>
                                    {equipment.category_description}-
                                    {equipment.PROD_BRAND} -
                                    {equipment.PROD_NAME}
                                  </option>
                                ))}
                              </>
                            )}
                          </>
                        }
                      />
                    </td>
                    <td>
                      <Input
                        placeholder={"RSP PRICE"}
                        value={item.RSP}
                        onChange={(event) => {
                          const inputValue = event.target.value;
                          if (
                            (inputValue?.length < 11 &&
                              /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(
                                inputValue
                              )) ||
                            event.target.value == 0
                          ) {
                            setAddProductData((prevData) => {
                              const updatedData = [...prevData];
                              updatedData[index] = {
                                ...updatedData[index],
                                RSP: /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(
                                  inputValue
                                )
                                  ? inputValue
                                  : "",
                                BASIC: "",
                                SGST: "",
                                CGST: "",
                                OFFER: "",
                              };
                              return updatedData;
                            });
                          }
                        }}
                      />
                    </td>
                    <td>
                      <Input
                        readOnly={true}
                        placeholder={"BASIC PRICE"}
                        value={item.BASIC}
                      />
                    </td>
                    <td>
                      <Input
                        placeholder={"SGST"}
                        readOnly={true}
                        value={item.SGST}
                      />
                    </td>
                    <td>
                      <Input
                        placeholder={"CGST"}
                        readOnly={true}
                        value={item.CGST}
                      />
                    </td>
                    <td>
                      <Input
                        placeholder={"OFFER PRICE"}
                        value={item.OFFER}
                        onChange={(event) => {
                          const inputValue = event.target.value;
                          if (
                            (inputValue?.length < 11 &&
                              /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(
                                inputValue
                              )) ||
                            event.target.value == 0
                          ) {
                            setAddProductData((prevData) => {
                              const updatedData = [...prevData];
                              updatedData[index] = {
                                ...updatedData[index],
                                OFFER: /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(
                                  inputValue
                                )
                                  ? inputValue
                                  : "",
                                BASIC: "",
                                SGST: "",
                                CGST: "",
                              };
                              return updatedData;
                            });
                          }
                        }}
                      />
                    </td>
                    <td>
                      <Input
                        type={"date"}
                        value={item.open_date}
                        onChange={(e) => {
                          if (e.target.value.length <= 10) {
                            setAddProductData((pre) =>
                              pre.map((v, i) =>
                                i == index
                                  ? { ...v, open_date: e.target.value }
                                  : { ...v }
                              )
                            );
                          }
                        }}
                      />
                    </td>
                    <td>
                      <DeleteIcon onClick={() => handleAddDelete(item.id)} />
                    </td>
                  </tr>
                ))}
              </>
            }
          />
          <div className="inp-error">
            * Please enter OFFER PRICE including with it's GST.
          </div>
        </>
      )}

      {blpg_price_loading ? (
        <PageLoading />
      ) : blpg_price_list?.length == 0 ? (
        <NoData />
      ) : (
        <>
          <Pagination2
            top={true}
            search={false}
            totalCount={totalCount}
            SerchInput={SerchInput}
            setSearchInput={setSearchInput}
            pageNo={pageNo}
            setPageNo={setPageNo}
            entries={entries}
            setEntries={setEntries}
          />
          <div className="grid">
            {blpg_price_list?.map((v, i) => (
              <div className="card" key={i}>
                <div className="card-heading">
                  {v?.cat_desc} - {v?.prod_brand} - {v?.prod_name}
                </div>
                <RowTxt title={"RSP PRICE"} value={v?.rsp} />
                <RowTxt
                  title={"OPENING DATE"}
                  value={
                    moment(v?.opening_date).format("DD-MMM-YYYY") ==
                    "Invalid date"
                      ? "Not Avalible"
                      : moment(v?.opening_date).format("DD-MMM-YYYY")
                  }
                />
                 <RowTxt title={"CREATED BY"} value={v?.CREATED_NAME || "-"} />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "1rem",
                  }}
                >
                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 1.05 }}
                    className="flex aic gap10 jce cursor-pointer"
                  >
                    <div className="view-btn" onClick={() => handleView(v)}>
                      View
                    </div>
                    <HiOutlineArrowRight
                      size={20}
                      color="#1b64af"
                      onClick={() => handleView(v)}
                    />
                  </motion.div>
                </div>
              </div>
            ))}
          </div>
          <Pagination2
            bottom={true}
            totalCount={totalCount}
            SerchInput={SerchInput}
            setSearchInput={setSearchInput}
            pageNo={pageNo}
            setPageNo={setPageNo}
            entries={entries}
            setEntries={setEntries}
          />
        </>
      )}

      {openViewModal && (
        <Modal
          isOpen={openViewModal}
          setIsOpen={setOpenViewModal}
          title={` ${viewItem?.cat_desc} - ${viewItem?.prod_brand} - ${viewItem?.prod_name}`}
          body={
            <>
              <Pagination2
                top={true}
                totalCount={viewItem?.items?.length}
                SerchInput={SerchInput1}
                setSearchInput={setSearchInput1}
                pageNo={pageNo1}
                setPageNo={setPageNo1}
                entries={entries1}
                setEntries={setEntries1}
              />
              <Table
                mt={0.1}
                headData={[
                  "PRODUCT",
                  "RSP PRICE",
                  "BASIC PRICE",
                  "SGST AMOUNT",
                  "CGST AMOUNT",
                  "OFFER PRICE",
                  "OPENING DATE",
                  "CLOSING DATE",
                ]}
                body={viewItem?.items
                  ?.slice(pageNo1 * entries1 - entries1, pageNo1 * entries1)
                  .map((v) => (
                    <tr>
                      <td>
                        {v?.cat_desc} - {v?.prod_brand} - {v?.prod_name}
                      </td>
                      <td>{v?.rsp}</td>
                      <td>{v?.base_price}</td>
                      <td>{v?.sgst_price}</td>
                      <td>{v?.cgst_price}</td>
                      <td>{v?.offer_price}</td>
                      <td>{moment(v?.opening_date).format("DD-MMM-YYYY")}</td>
                      <td>
                        {moment(v?.closing_date).format("DD-MMM-YYYY") ==
                        "Invalid date"
                          ? "-"
                          : moment(v?.closing_date).format("DD-MMM-YYYY")}
                      </td>
                    </tr>
                  ))}
              ></Table>
              <Pagination2
                bottom={true}
                totalCount={viewItem?.items?.length}
                SerchInput={SerchInput1}
                setSearchInput={setSearchInput1}
                pageNo={pageNo1}
                setPageNo={setPageNo1}
                entries={entries1}
                setEntries={setEntries1}
              />
            </>
          }
        />
      )}

      {showDeleteAlert && (
        <SmallModal
          isOpen={showDeleteAlert}
          setIsOpen={setShowDeleteAlert}
          onClick={() => handleDeleteProduct(DeleteId)}
          title={"Confirm"}
          mess={"Are you sure? You want to delete"}
        />
      )}

      {showPinVerify && (
        <PinVerify
          showPinVerify={showPinVerify}
          setShowPinVerify={setShowPinVerify}
          setShowLoader={setShowLoader}
          setAlertOpen={setPinAlert}
          setAlertMess={setPinAlertMess}
        />
      )}

      {pinALert && (
        <SmallModal
          isOpen={pinALert}
          setIsOpen={setPinAlert}
          title={"alert"}
          mess={pinAlertMess}
          okbtn={setPinAlert}
        />
      )}
      {showLoader && <Loader loading={showLoader} />}
    </div>
  );
};
